export var Status;
(function (Status) {
    Status[Status["Init"] = 0] = "Init";
    Status[Status["Prepare"] = 1] = "Prepare";
    Status[Status["Incompare"] = 2] = "Incompare";
    Status[Status["Finish"] = 3] = "Finish"; // 对比后
})(Status || (Status = {}));
